import React from "react";
import { AUDITS } from "../../../core/theme/auditsTheme";
import { useAccount } from "../../../core/hooks/useAccount";
import { canUseIndustryAudits } from "../../../core/data/account";
import useNicheRollup from "../useNicheRollup";
import NicheCountsCheck from "./NicheCountsCheck";

// The Audits page's left column. Accounts with Industry Audits see the niche
// counts (a temporary plain list until stage 3); everyone else keeps the
// placeholders.
export default function AuditsSidePanel() {
  const account = useAccount();
  const industryAudits = canUseIndustryAudits(account);
  const rollup = useNicheRollup(account ? account.agencyId : null, industryAudits);

  return (
    <aside className={AUDITS.side}>
      {industryAudits ? (
        <section>
          <h2 className={`${AUDITS.title} mb-3`}>Industry Audit counts</h2>
          <NicheCountsCheck state={rollup} />
        </section>
      ) : (
        <section>
          <h2 className={`${AUDITS.title} mb-3`}>Your area</h2>
          <div className={AUDITS.placeholder}>Your industry and area summary will appear here.</div>
        </section>
      )}
      <section>
        <h2 className={`${AUDITS.title} mb-3`}>What you have</h2>
        <div className={AUDITS.placeholder}>Suggested searches will appear here.</div>
      </section>
    </aside>
  );
}
